import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { NavLink } from 'react-router-dom';
import moment from 'moment';
import { find, cloneDeep, get, capitalize, map } from 'lodash';
import config from '../../config/config'
import store from '../../helpers/store'
import { sessionStore } from '../../helpers/SessionStore'
import ReactSelect from '../../components/common/ReactSelect';
import Spinner from '../../components/common/Spinner';
import TopTracks from '../../components/pages/spotifyDiscovery/TopTracks';
import BarChart from '../../components/pages/spotifyDiscovery/BarChart';
import MetricChart from '../../components/pages/spotifyDiscovery/MetricChart';
import MatchMediaWrapper from '../../helpers/MatchMediaWrapper';
import CatalogOverview from '../../components/pages/spotifyMonetization/Overview';
import SearchWidget from '../../components/pages/home/SearchWidget';
import Datepicker from '../../components/common/Datepicker';

import {Widget, WithWidgetManager, HiddenElements} from '../../components/widgets/manager';

import { statsActions } from '../../data/actions/stats';
import { milestonesActions } from '../../data/actions/milestones';
import { spotifyDiscoveryActions } from '../../data/actions/spotify_discovery';


class SpotifyDiscoveryDetails extends React.Component {

	constructor(props){
		super(props);
		// const currentFilter = store.get('userSearch') || null;
		this.state = {
			id: null,
			prevDateStart: null,
			prevDateEnd: null,
			dateStart: null,
			dateEnd: null,
			range: null,
			missingMilestone: false
		}  
		this.getData = this.getData.bind(this);
		this.persistState = this.persistState.bind(this);
	}    
	
	persistState(){
		sessionStore.set('spotifyDiscoveryScorecard', this.state);
	}    
	
	componentDidMount(){
		const { match } = this.props; 
		this.getData(match.params.id);
	}
	
	componentWillReceiveProps(nextProps){
		const { match } = nextProps;
		if(match.params.id != this.props.match.params.id) {
			this.getData(match.params.id);
		}
	}
	
	searchResult = (track) => {
		this.props.history.push(`/spotify-discovery/scorecard/${track.id}`)
	}
	
	removeSearchResult = () => {
		this.setState({
			id: null
		}, ()=>{
			this.persistState();
			this.props.history.push(`/spotify-discovery/scorecard`)	
		})
		
	}

	
	dateChange(date, field){
		const { dispatch } = this.props; 
		const { start, end } = this.state;
		
		date = moment(date);
		const otherDate = moment(field == 'dateStart' ? end : start);
		const range = Math.abs(date.diff(otherDate, 'days')) > 180 ? 'mth' : 'clwk';
		this.setState({
		  ...this.state,
		  [field]: date.format('YYYY-MM-DD'),
		  range
		}, ()=>{
			dispatch(spotifyDiscoveryActions.getSpotifyDiscoveryDetailsTimeseries(this.state))
		});
	}
	
	getData(id){
		const { dispatch } = this.props;
		if(!id)
			return dispatch(spotifyDiscoveryActions.resetSpotifyDiscoveryDetailsTimeseries());
			
		return Promise.all([
			dispatch(statsActions.getMultiEntitiesMetadata({tracks: [id]})),
			dispatch(milestonesActions.getDiscoveryMilestones('tracks', [id])),
			dispatch(spotifyDiscoveryActions.resetSpotifyDiscoveryDetailsTimeseries())
		]).then(([metadata, milestone])=>{
			if(milestone) {
				const addedOn = moment(milestone.occurs_at);
				const prevEnd =  moment(addedOn).subtract(1, 'day');
				const prevStart = moment(prevEnd).subtract(28, 'day');
				const end =  moment().subtract(2, 'day');
				const start =  moment(end).subtract(28, 'day');
				
				let trackTitle = 'N/A';
				let trackImage = null;
				if(Array.isArray(metadata) && metadata.length) {
					const track = metadata[0];
					trackTitle = `${track.name} (${track.code}) added on ${addedOn.format('YYYY-MM-DD')}`;
					trackImage = track.image;
				} 	
				
				return this.setState({
					prevDateStart: prevStart.format('YYYY-MM-DD'),
					prevDateEnd: prevEnd.format('YYYY-MM-DD'),
					dateStart: start.format('YYYY-MM-DD'),
					dateEnd: end.format('YYYY-MM-DD'),
					id,
					range: 'clwk',
					trackTitle,
					trackImage,
					missingMilestone: false
				}, ()=>{
					this.persistState();
					return dispatch(spotifyDiscoveryActions.getSpotifyDiscoveryDetailsTimeseries(this.state))
				});
			} else {
				return this.setState({
					missingMilestone: true,
					id: null
				});
			}
		});

	}
	render() {
		const { widgetProps, spotifyDiscovery, match } = this.props;
		const { detailsTimeseries, loadingDetailsTimeseries  } = spotifyDiscovery;
		const { trackTitle, missingMilestone, trackImage } = this.state;
		const overviewState = sessionStore.get('spotifyDiscoveryList');
		const overviewArtists = get(overviewState, 'track_artists', null);
		const overviewRange = get(overviewState, 'range', null); 
		
		return <div className="inner-page result-page discovery-details-page"> 
			<div className="inner-page">
				<div className="spotify-discovery-header">
					<h1 className="spotify-discovery-header-title">
						Spotify Discovery Mode
					</h1>
					<ul className="profile-navigation">
						<NavLink className="profile-navigation-link" to={`/spotify-discovery/overview${overviewRange?'/'+overviewRange:''}${overviewArtists?'/'+overviewArtists:''}`}>Overview</NavLink>
						<NavLink className="profile-navigation-link" to={`/spotify-discovery/scorecard`}>Scorecard</NavLink>
					</ul>
				</div>

				{missingMilestone && <strong>This track is not a part of Spotify Discovery</strong>}
				{loadingDetailsTimeseries && <Spinner enabled={true} />}
				{detailsTimeseries && <React.Fragment>
					<div className="artist-profile-holder">
						<div className="artist-profile-logo" style={{backgroundImage: `url(${trackImage})`}} >
						</div>
						<div className="artist-info-holder">
								<div className="artist-main-info">
										<div className="profile-recent-search-holder">
												<div className="details-header-list">
														<div className="details-header-item">
															<span className="">{trackTitle}
															<a
																className="close-link"
																onClick={()=>this.removeSearchResult()}
															>
																&times;
															</a>
															</span>
														</div>
												</div>
										</div>
								</div>
									
								<CatalogOverview stats={detailsTimeseries.metrics} />
						</div>
					</div>
				</React.Fragment>}

				<div className="discovery-filter-holder">
					<div className="discovery-filter-row">
						<div className="discovery-filter-item discovery-filter-item-search discovery-filter-search-with-date">
							<SearchWidget searchResult={this.searchResult} placeholder="Search tracks" entities={['tracks']} mode="milestone" />
						</div>
						<div id="new-releases-header-start" className='discovery-filter-item discovery-filter-item-date'>
							<div className='filter-date-holder'>
								<div className="new-release-datepicker">
									<Datepicker date={this.state.dateStart} placeholder={'Choose Start Date'} dateChange={(date)=>this.dateChange(date, 'dateStart')} container="#new-releases-header-start" />
								</div>
								<div className="new-release-datepicker">
									<Datepicker  date={this.state.dateEnd} placeholder={'Choose End Date'} dateChange={(date)=>this.dateChange(date, 'dateEnd')}  container="#new-releases-header-end" />
								</div>
							</div>
						</div>
					</div>
				</div>
				
				{detailsTimeseries && <React.Fragment>
					<BarChart data={detailsTimeseries} title="Spotify Radio and Collection Streams" period={"clwk"} />	
				</React.Fragment>}
			</div>
			
		</div>
	}
}

function mapStateToProps(state) {
	return {
		stats: state.stats,
		milestones: state.milestones,
		spotifyDiscovery: state.spotifyDiscovery 
	} 
}
export default withRouter(connect(mapStateToProps)(SpotifyDiscoveryDetails));